import gql from 'graphql-tag';
import { apolloClient } from '@/vue-apollo';

export default {
  async getCarsBrands() {
    const result = await apolloClient.query({
      query: gql`query {
        brands(
          distinct_on: name,
          where: { validated: { _eq: true, }, },
        ) {
          name
          logo
        }
      }`,
    });

    return result.data.brands;
  },
};
